import { isGroupTableQuery } from 'owa-group-common';
export function shouldTableSupportFlag(tableQuery) {
    // Support flagging in Search and Folder
    return (!isGroupTableQuery(tableQuery) &&
        (tableQuery.type == 1 /* Search */ || tableQuery.type == 0 /* Folder */));
}
//# sourceMappingURL=shouldTableSupportFlag.js.map